export let showMessageOptions = "is0e6";
export default {showMessageOptions};